import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { getText } from 'misc/helpers';

class InputField extends Component {
    constructor(props) {
        super(props);

        let showWarning = true;
        if (props.noStartWarning) {
            showWarning = false;
        }
        this.state = {
            showWarning: showWarning
        };
    }
    getClassName(showWarning, error, pending) {
        if (showWarning && error) {
            return 'input-error';
        }
        if (pending) {
            return 'input-warning';
        }
        return '';
    }

    render = () => {
        const renderField = ({ input, label, type, meta: { touched, error, warning } }) => (
            <div className="input-field">
                <div className="input-container">
                    {this.props.icon &&
                        <div className="input-field-icon">
                            <img src={this.props.icon} alt="" className={this.props.iconClass}/>
                        </div>
                    }
                    <input {...input} maxLength={this.props.maxlength} placeholder={this.props.placeholder} type={type} />
                </div>

                <hr className={this.getClassName(this.state.showWarning || touched, error, this.props.pending)} />
                {(this.state.showWarning || touched) &&
                    error && (
                        <div className="error-message">
                            {error}
                            <i className="fa fa-exclamation-triangle error" aria-hidden="true" />
                        </div>
                    )}
                {this.props.pending && (
                    <div className="warning-message">
                        {getText('Missing', 'Dina nya uppgifter behandlas.')}
                        <i className="fa fa-exclamation-triangle warning" aria-hidden="true" />
                    </div>
                )}
            </div>
        );

        return <Field name={this.props.name} type={this.props.text} component={renderField} validate={this.props.validate} />;
    };
}

export default connect()(InputField);



// WEBPACK FOOTER //
// ./src/components/shared/form/InputField.js